var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"highlight-box rich-text",class:_vm.data.border_color,domProps:{"innerHTML":_vm._s(_vm.$prismic.asHtml(_vm.data.content))}})}
var staticRenderFns = []

export { render, staticRenderFns }